import {
  Button,
  Colors,
  Cross,
  Icon,
  Input,
  Modal,
  Typography
} from '@giantleap/components-library'
import { CircularProgress } from '@material-ui/core'
import { functions } from 'config/firebase'
import mixpanel from 'mixpanel-browser'
import * as React from 'react'
import SnackbarService from 'services/snackbars'
import styles from './style.module.scss'
import { IProps, IState } from './types'

const required = value => (value ? undefined : 'Required')
const checkEmail = value =>
  value &&
  !/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i.test(
    value
  )
    ? 'Invalid email'
    : undefined

const ShareWithTeacherModal = (props: IProps) => {
  const { open, setActive } = props
  const [name, setName] = React.useState<IState['name']>('')
  const [email, setEmail] = React.useState<IState['email']>('')
  const [loading, setLoading] = React.useState(false)

  const onShare = async () => {
    try {
      setLoading(true)
      const { currentPatient, userName, userId } = props
      if (required(name) || required(email)) {
        setLoading(false)
        SnackbarService.showSnackbar('name and email are required', 'error')
        return
      }
      if (checkEmail(email)) {
        setLoading(false)
        SnackbarService.showSnackbar('incorrect email format', 'error')
        return
      }
      const share = await shareWithEducator({
        name,
        email,
        child_id: currentPatient.patientId,
        child_name: currentPatient.first_name,
        parent_name: userName
      })

      if (share && share.data) {
        if (share.data.error) {
          SnackbarService.showSnackbar(share.data.error, 'error')
          setLoading(false)
        } else {
          setLoading(false)
          setActive(false)
          SnackbarService.showSnackbar(`Invite sent to ${name}`, 'success')
          mixpanel.identify(userId)
          mixpanel.track('Shared with Educator')
        }
      } else {
        SnackbarService.showSnackbar(
          'error occured while sharing. try again later',
          'error'
        )
        setLoading(false)
      }
    } catch (e) {
      SnackbarService.showSnackbar(
        'error occured while sharing. try again later',
        'error'
      )
      setLoading(false)
    }
  }

  const shareWithEducator = functions.httpsCallable('shareWithEducator')

  return (
    <Modal
      active={open}
      setActive={setActive}
      baseClassName={styles.wrap}
      x={<Cross size="big" color={Colors.unselected} />}
    >
      <Typography
        type="title"
        size="big"
        className={styles.title}
        textAlign="left"
      >
        Share with Teacher
      </Typography>
      <Typography type="text" className={styles.text} textAlign="left">
        Sharing grants viewing access to your child’s results.
      </Typography>
      <form
        className="share-with-educator-form"
        noValidate={true}
        autoComplete="off"
      >
        <Input
          hint="Teacher’s Name"
          placeholder="Michelle Robinson"
          onChange={event => setName(event.target?.value)}
        />
        <Input
          hint="Teacher’s Email"
          placeholder="address@gmail.com"
          onChange={event => setEmail(event.target?.value)}
        />
      </form>
      {loading ? (
        <div className={styles.loading}>
          <CircularProgress
            size={'2em'}
            classes={{
              circle: styles.loading__circle,
              colorPrimary: `${styles.loading} ${styles.loading_primary}`
            }}
          />
        </div>
      ) : (
        <Button
          beforeIcon={<Icon type="checkmark" color={Colors.white} />}
          color="black"
          type="sm"
          className={styles.button}
          onClick={onShare}
        >
          Share
        </Button>
      )}
    </Modal>
  )
}

export default ShareWithTeacherModal



// WEBPACK FOOTER //
// ./src/components/ShareWithTeacherModal/index.tsx